<template>
  <section class="front-container">
    <figure class="logo-container">
      <a href="https://www.osfatun.com.ar/" target="_blank"><img src="./../../assets/logo-header.svg" width="200px" alt="osfatun" /></a>
    </figure>
    <div class="linkthree-container">
      <div class="container-fluid">
        <div class="columns">
          <div class="column" style="text-align: center;">
            <h2 class="title title-icons"><strong>¡Hola!</strong> <span>Estamos realizando tareas de mantenimiento</span></h2>
            <p>Hasta entonces, te dejamos a disposición los siguientes accesos:</p>
          </div>
        </div>
        <ul class="icons">
          <li class="circle">
            <a href="http://mi.osfatun.com.ar/">
              <strong>Mi OSFATUN</strong> <br />
              -Trámites Online-
            </a>
          </li>
          <li class="circle">
            <a href="http://afiliate.osfatun.com.ar/">
              <strong>QUIERO AFILIARME</strong>
            </a>
          </li>
          <li class="circle">
            <a href="https://prestadores.osfatun.com.ar/"><strong>Cartilla de prestadores</strong> </a>
          </li>
          <!--<li class="circle">
            <a href="https://www.osfatun.com.ar/planes/"><strong>Planes</strong></a>
          </li>-->
          <!--<li class="circle">
            <a href="https://www.osfatun.com.ar/delegaciones/"><strong>Delegaciones</strong></a>
          </li>-->
          <li class="circle">
            <a href="https://facturacion.osfatun.com.ar/"><strong>Facturación Prestadores</strong> </a>
          </li>

        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LandingHeader",
};
</script>

<style scoped>
.front-container {
  max-width: 80%;
  margin: 0 auto;
}
.logo-container {
  padding-top: 50px;
  padding-bottom: 60px;
}
.logo-container img {
  display: block;
  margin: 0px auto;
}
.linkthree-container {
  background-color: #fff;
  padding: 3%;
}
h2.title.title-icons {
  font-weight: bold;
  font-size: 36px;
  text-transform: uppercase;
  color: #00758f;
  width: 100%;
  text-align: center;
  padding: 40px 0;
}
ul.icons li a{
  color: #fff;
  font-size: 16px;
  line-height: 1.3rem;
}
ul.icons li a strong{
  text-transform: uppercase;
}

.circle {
  background: rgb(0, 147, 191);
  background: linear-gradient(
    54deg,
    rgba(0, 147, 191, 1) 0%,
    rgba(0, 117, 143, 1) 100%
  );
  color: #fff;
  display: flexbox;
  padding: 10px;
  border-radius: 100%;
  vertical-align: middle;
  width: 185px;
  height: 185px;
  border: 0;
  position: relative;
}
.circle:hover{
  border:3px solid #f5a22d;
}
.headerDegraded {
  background: rgb(0, 147, 191);
  background: linear-gradient(
    54deg,
    rgba(0, 147, 191, 1) 0%,
    rgba(0, 117, 143, 1) 100%
  );
}
@media screen and (max-width: 42em) {
  ul.icons li:last-child{ display: grid; }
  .front-container{
    max-width:90%;
  }
  h2.title.title-icons{ padding: 20px 0; }
  h2.title.title-icons strong{ display: block; font-size: 56px; }
  h2.title.title-icons span{ font-size: 20px;}
  .circle{
    width: 150px;
    height: 150px;
    padding: 5px;
  }

}
</style>
